export var SUBMISSION_QUESTIONS_SCROLL_SELECTOR = '[data-submission-questions-scroll]';
var SCROLL_OFFSET_PX = 24;

var findScrollableAncestor = function findScrollableAncestor(element) {
  var node = element.parentElement;

  while (node && node !== document.body) {
    if (node.closest('[data-testid="section-summary-content"]')) {
      node = node.parentElement;
      continue;
    }

    var _window$getComputedSt = window.getComputedStyle(node),
        overflowY = _window$getComputedSt.overflowY;

    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
      return node;
    }

    node = node.parentElement;
  }

  return null;
};

var scrollElementWithinContainer = function scrollElementWithinContainer(element, container) {
  var containerRect = container.getBoundingClientRect();
  var elementRect = element.getBoundingClientRect();
  var scrollTop = elementRect.top - containerRect.top + container.scrollTop - SCROLL_OFFSET_PX;
  var maxScrollTop = container.scrollHeight - container.clientHeight;
  container.scrollTo({
    top: Math.min(Math.max(0, scrollTop), maxScrollTop),
    behavior: 'smooth'
  });
};
/**
 * Scrolls the main submission questions column to the question with id `form-{questionId}`.
 */


export var scrollToSubmissionQuestion = function scrollToSubmissionQuestion(questionId, options) {
  var _options$delayMs, _options$retryMs;

  var delayMs = (_options$delayMs = options === null || options === void 0 ? void 0 : options.delayMs) !== null && _options$delayMs !== void 0 ? _options$delayMs : 100;
  var retryMs = (_options$retryMs = options === null || options === void 0 ? void 0 : options.retryMs) !== null && _options$retryMs !== void 0 ? _options$retryMs : 250;

  var attemptScroll = function attemptScroll() {
    var questionElement = document.getElementById("form-".concat(questionId));

    if (!questionElement) {
      return false;
    }

    var markedContainer = document.querySelector(SUBMISSION_QUESTIONS_SCROLL_SELECTOR);
    var scrollableContainer = markedContainer !== null && markedContainer !== void 0 ? markedContainer : findScrollableAncestor(questionElement);

    if (scrollableContainer) {
      scrollElementWithinContainer(questionElement, scrollableContainer);
    } else {
      questionElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    return true;
  };

  window.setTimeout(function () {
    if (!attemptScroll()) {
      window.setTimeout(attemptScroll, retryMs);
    }
  }, delayMs);
};